/* stone-engine.js, GENERATED by stone/sync.mjs, do not edit by hand.
 * Engine: Customeadoor/customea-3d-planner 5ddb22a504ab1c11c928bd7b331ad4e72f582550 (2026-10-08T19:00:52+11:00),
 *   apps/web/lib/benchtop-estimate.ts + benchtop-prices.ts, bundled with esbuild,
 *   plus stone/src/website-input.mjs (the website's sections -> engine input).
 * Prices: CustomeaAccount markup to print - Retail Price 20/9/2026, every figure EX GST, price list dated 2026-09-20.
 * Estimate only. Nothing here is a product, a variant or a cart line.
 */
var CustomeaStoneEngine = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // stone-engine-entry.ts
  var stone_engine_entry_exports = {};
  __export(stone_engine_entry_exports, {
    ALL_COLOUR_PRICES: () => ALL_COLOUR_PRICES,
    AREA_STEP_SQM: () => AREA_STEP_SQM,
    BENCHTOP_BANDS_EX_GST: () => BENCHTOP_BANDS_EX_GST,
    BENCHTOP_COLOUR_PRICES: () => BENCHTOP_COLOUR_PRICES,
    BENCHTOP_EDGES: () => BENCHTOP_EDGES,
    BENCHTOP_ESTIMATE_DISCLAIMER: () => BENCHTOP_ESTIMATE_DISCLAIMER,
    BENCHTOP_NOT_IN_TOTAL: () => BENCHTOP_NOT_IN_TOTAL,
    CUTOUT_PRICES: () => CUTOUT_PRICES,
    DEFAULT_EDGE: () => DEFAULT_EDGE,
    EDGE_STEP_M: () => EDGE_STEP_M,
    EXTRAS: () => EXTRAS,
    EXTRA_IDS: () => EXTRA_IDS,
    GST_RATE: () => GST_RATE,
    MATERIAL_LABEL: () => MATERIAL_LABEL,
    MINIMUM_STONE_SQM: () => MINIMUM_STONE_SQM,
    NOTHING_TO_PRICE_NOTE: () => NOTHING_TO_PRICE_NOTE,
    POLISH_UNDERSIDE: () => POLISH_UNDERSIDE,
    PORCELAIN_BANDS_EX_GST: () => PORCELAIN_BANDS_EX_GST,
    PORCELAIN_COLOUR_PRICES: () => PORCELAIN_COLOUR_PRICES,
    PORCELAIN_CUTOUT_PRICES: () => PORCELAIN_CUTOUT_PRICES,
    PORCELAIN_EDGES: () => PORCELAIN_EDGES,
    SINK_CUTOUT_IDS: () => SINK_CUTOUT_IDS,
    SITE_TEMPLATE_FEE_EX_GST: () => SITE_TEMPLATE_FEE_EX_GST,
    SLAB_LENGTH_MM: () => SLAB_LENGTH_MM,
    VEIN_MATCHING: () => VEIN_MATCHING,
    WATERFALL_INSTALL_EX_GST: () => WATERFALL_INSTALL_EX_GST,
    bandLabel: () => bandLabel,
    colourRateExGst: () => colourRateExGst,
    colourThicknesses: () => colourThicknesses,
    cutoutPrice: () => cutoutPrice,
    cutoutsFor: () => cutoutsFor,
    defaultThickness: () => defaultThickness,
    edgeOption: () => edgeOption,
    edgesAvailable: () => edgesAvailable,
    edgesFor: () => edgesFor,
    estimateBenchtop: () => estimateBenchtop,
    estimateFigure: () => estimateFigure,
    extraOption: () => extraOption,
    formatAud: () => formatAud,
    incGst: () => incGst,
    rateFor: () => rateFor,
    resolveEdge: () => resolveEdge,
    resolveThickness: () => resolveThickness,
    roundCents: () => roundCents,
    roundEdgeM: () => roundEdgeM,
    roundUpSqm: () => roundUpSqm,
    sinkCutoutIdsFor: () => sinkCutoutIdsFor,
    waterfallInstallExGst: () => waterfallInstallExGst,
    website: () => website_input_exports
  });

  // .planner-src/assets/benchtop/price-list.json
  var price_list_default = {
    _comment: "Generated by scripts/parse-benchtop-price-list.py from Caesarstone's retail price list PDF. Every figure is EX GST (Mat, 2026-09-20). Colours are the 45 Mineral 20mm decors in five per-sqm bands; edges per metre; cutouts and extras each. porcelainColours carry a rate per thickness (12 / 20 mm) the list prices; porcelainEdges / porcelainCutouts / porcelainExtras are the list's own porcelain lines.",
    source: "CustomeaAccount markup to print - Retail Price 20/9/2026",
    exGst: true,
    colours: [
      {
        id: "1141-pure-white",
        code: "1141",
        name: "Pure White",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "2141-snow",
        code: "2141",
        name: "Snow",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "3100-jet-black",
        code: "3100",
        name: "Jet Black",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "3141-osprey",
        code: "3141",
        name: "Osprey",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "4030-oyster",
        code: "4030",
        name: "Oyster",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "4120-raven",
        code: "4120",
        name: "Raven",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "6011-intense-white",
        code: "6011",
        name: "Intense White",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "6141-ocean-foam",
        code: "6141",
        name: "Ocean Foam",
        finish: "P",
        note: null,
        pricePerSqmExGst: 505
      },
      {
        id: "4001-fresh-concrete",
        code: "4001",
        name: "Fresh Concrete",
        finish: "CN",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "4004-raw-concrete",
        code: "4004",
        name: "Raw Concrete",
        finish: "CN",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "4600-organic-white",
        code: "4600",
        name: "Organic White",
        finish: "P",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "5110-alpine-mist",
        code: "5110",
        name: "Alpine Mist",
        finish: "P",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "5112-aterra-blanca",
        code: "5112",
        name: "Aterra Blanca",
        finish: "P",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "5130-cosmopolitan-white",
        code: "5130",
        name: "Cosmopolitan White",
        finish: "P",
        note: "Backorder",
        pricePerSqmExGst: 563.75
      },
      {
        id: "5133-symphony-grey",
        code: "5133",
        name: "Symphony Grey",
        finish: "P",
        note: "Low Stock",
        pricePerSqmExGst: 563.75
      },
      {
        id: "5141-frosty-carina",
        code: "5141",
        name: "Frosty Carina",
        finish: "P",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "5146-misty-river",
        code: "5146",
        name: "Misty River",
        finish: "P",
        note: null,
        pricePerSqmExGst: 563.75
      },
      {
        id: "6134-georgian-bluffs",
        code: "6134",
        name: "Georgian Bluffs",
        finish: "P",
        note: "Low Stock",
        pricePerSqmExGst: 563.75
      },
      {
        id: "5100-vanilla-noir",
        code: "5100",
        name: "Vanilla Noir",
        finish: "P",
        note: "Backorder",
        pricePerSqmExGst: 633.75
      },
      {
        id: "5102-lace-line",
        code: "5102",
        name: "Lace Line",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5103-light-crest",
        code: "5103",
        name: "Light Crest",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5131-calacatta-nuvo",
        code: "5131",
        name: "Calacatta Nuvo",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5140-dreamy-carrara",
        code: "5140",
        name: "Dreamy Carrara",
        finish: "H",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5143-white-attica",
        code: "5143",
        name: "White Attica",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5151-empira-white",
        code: "5151",
        name: "Empira White",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "5310-brillianza",
        code: "5310",
        name: "Brillianza",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "6131-bianco-drift",
        code: "6131",
        name: "Bianco Drift",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "6313-turbine-grey",
        code: "6313",
        name: "Turbine Grey",
        finish: "P",
        note: null,
        pricePerSqmExGst: 633.75
      },
      {
        id: "4011-cloudburst-concrete-csf",
        code: "4011",
        name: "Cloudburst Concrete CSF",
        finish: "OR",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "4033-rugged-concrete",
        code: "4033",
        name: "Rugged Concrete",
        finish: "R",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "4044-airy-concrete-csf",
        code: "4044",
        name: "Airy Concrete CSF",
        finish: "OR",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5031-statuario-maximus",
        code: "5031",
        name: "Statuario Maximus",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5113-solenna",
        code: "5113",
        name: "Solenna",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5171-arabetto",
        code: "5171",
        name: "Arabetto",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5222-adamina",
        code: "5222",
        name: "Adamina",
        finish: "OR",
        note: "Backorder",
        pricePerSqmExGst: 807.5
      },
      {
        id: "5441-glacier-flow",
        code: "5441",
        name: "Glacier Flow",
        finish: "P",
        note: "Low Stock",
        pricePerSqmExGst: 807.5
      },
      {
        id: "5444-lunar-frost",
        code: "5444",
        name: "Lunar Frost",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5810-black-tempal",
        code: "5810",
        name: "Black Tempal",
        finish: "OR",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "8252-sedara",
        code: "8252",
        name: "Sedara",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "8252-taj-whisper",
        code: "8252",
        name: "Taj Whisper",
        finish: "P",
        note: null,
        pricePerSqmExGst: 807.5
      },
      {
        id: "5105-calacatta-dreamwave",
        code: "5105",
        name: "Calacatta Dreamwave",
        finish: "P",
        note: null,
        pricePerSqmExGst: 981.25
      },
      {
        id: "5115-calacatta-stillstorm",
        code: "5115",
        name: "Calacatta Stillstorm",
        finish: "P",
        note: null,
        pricePerSqmExGst: 981.25
      },
      {
        id: "5132-celestial-sky",
        code: "5132",
        name: "Celestial Sky",
        finish: "P",
        note: null,
        pricePerSqmExGst: 981.25
      },
      {
        id: "5144-rossa-nova",
        code: "5144",
        name: "Rossa Nova",
        finish: "P",
        note: null,
        pricePerSqmExGst: 981.25
      },
      {
        id: "8100-calacatta-lacebound",
        code: "8100",
        name: "Calacatta Lacebound",
        finish: "P",
        note: null,
        pricePerSqmExGst: 981.25
      }
    ],
    bands: [
      505,
      563.75,
      633.75,
      807.5,
      981.25
    ],
    edges: [
      {
        id: "20mm-aris",
        name: "20mm - Aris",
        pricePerMExGst: 62.5
      },
      {
        id: "20mm-bullnose",
        name: "20mm - Bullnose",
        pricePerMExGst: 151.25
      },
      {
        id: "20mm-lambs-tongue-classic",
        name: "20mm - Lambs Tongue - Classic",
        pricePerMExGst: 343.75
      },
      {
        id: "20mm-pencil-round",
        name: "20mm - Pencil Round",
        pricePerMExGst: 62.5
      },
      {
        id: "20mm-shark-nose",
        name: "20mm - Shark Nose",
        pricePerMExGst: 151.25
      },
      {
        id: "20mm-splayed",
        name: "20mm - Splayed",
        pricePerMExGst: 151.25
      },
      {
        id: "40mm-bullnose",
        name: "40mm - Bullnose",
        pricePerMExGst: 481.25
      },
      {
        id: "40mm-lambs-tongue-provincial",
        name: "40mm - Lambs Tongue - Provincial",
        pricePerMExGst: 522.5
      },
      {
        id: "40mm-lambs-tongue-traditional",
        name: "40mm - Lambs Tongue - Traditional",
        pricePerMExGst: 536.25
      },
      {
        id: "40mm-laminate",
        name: "40mm - Laminate",
        pricePerMExGst: 123.75
      },
      {
        id: "double-mitred-aris",
        name: "Double Mitred - Aris",
        pricePerMExGst: 172.5
      },
      {
        id: "double-mitred-pencil-round",
        name: "Double Mitred - Pencil Round",
        pricePerMExGst: 172.5
      },
      {
        id: "mitred-aris",
        name: "Mitred - Aris",
        pricePerMExGst: 123.75
      },
      {
        id: "mitred-pencil-round",
        name: "Mitred - Pencil Round",
        pricePerMExGst: 123.75
      }
    ],
    cutouts: [
      {
        id: "cooktop-cutout",
        name: "Cooktop Cutout",
        priceEachExGst: 76.25
      },
      {
        id: "cs-opt-farmhouse-sink-20mm-inner-edge",
        name: "CS OPT - Farmhouse Sink 20mm inner edge",
        priceEachExGst: 343.75
      },
      {
        id: "drop-in-sink",
        name: "Drop in Sink",
        priceEachExGst: 76.25
      },
      {
        id: "farmhouse-sink-40mm-inner-edge",
        name: "Farmhouse Sink 40mm inner edge",
        priceEachExGst: 550
      },
      {
        id: "gpo-cutout",
        name: "GPO Cutout",
        priceEachExGst: 35
      },
      {
        id: "rough-cutout",
        name: "Rough Cutout",
        priceEachExGst: 90
      },
      {
        id: "tap-hole",
        name: "Tap Hole",
        priceEachExGst: 27.5
      },
      {
        id: "undermount-sink-double-bowl",
        name: "Undermount Sink (Double Bowl)",
        priceEachExGst: 357.5
      },
      {
        id: "undermount-sink-single-bowl",
        name: "Undermount Sink (Single Bowl)",
        priceEachExGst: 275
      }
    ],
    extras: [
      {
        id: "additional-travel-charge-per-km-50km-from-fabricator",
        name: "Additional Travel Charge (per km > 50km from fabricator)",
        priceExGst: 8.75
      },
      {
        id: "additional-trip-charge",
        name: "Additional Trip Charge",
        priceExGst: 275
      },
      {
        id: "diy-surcharge",
        name: "DIY surcharge",
        priceExGst: 825
      },
      {
        id: "drop-down-bbq-niche",
        name: "Drop down BBQ Niche",
        priceExGst: 343.75
      },
      {
        id: "heavy-lift-charge-per-job-where-single-piece-2-5sqm",
        name: "Heavy Lift Charge (per job where single piece > 2.5sqm)",
        priceExGst: 343.75
      },
      {
        id: "high-rise-difficult-access-charge",
        name: "High Rise & Difficult Access Charge",
        priceExGst: 343.75
      },
      {
        id: "install-on-existing-joinery",
        name: "Install on Existing Joinery",
        priceExGst: 550
      },
      {
        id: "miscellaneous-charge",
        name: "Miscellaneous Charge",
        priceExGst: 1.25
      },
      {
        id: "polish-underside-of-overhangs-up-to-300mm",
        name: "Polish Underside of Overhangs (up to 300mm)",
        priceExGst: 110
      },
      {
        id: "site-template-fee",
        name: "Site Template Fee",
        priceExGst: 261.25
      },
      {
        id: "vein-matching",
        name: "Vein Matching",
        priceExGst: 343.75
      },
      {
        id: "waterfall-end-installation-only",
        name: "Waterfall End (Installation only)",
        priceExGst: 247.5
      }
    ],
    porcelain: [
      {
        name: "110 Whitenna 12mm-Honed",
        type: "Porcelain",
        price: 628.75
      },
      {
        name: "411 Concrita 12mm-Ultra Rough",
        type: "Porcelain",
        price: 628.75
      },
      {
        name: "504 Lumena 12mm-Honed",
        type: "Porcelain",
        price: 628.75
      },
      {
        name: "531 Libretta 12mm-Honed",
        type: "Porcelain",
        price: 628.75
      },
      {
        name: "580 Fume 12mm-Honed",
        type: "Porcelain",
        price: 628.75
      },
      {
        name: "110 Whitenna 20mm-Honed",
        type: "Porcelain",
        price: 830
      },
      {
        name: "504 Lumena 20mm-Honed",
        type: "Porcelain",
        price: 830
      },
      {
        name: "531 Libretta 20mm-Honed",
        type: "Porcelain",
        price: 830
      },
      {
        name: "311 Graphite Metal 12mm Honed Porcelain",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "410 Aluminous 12mm-Ultra Rough",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "413 White Ciment 12mm-Ultra Rough",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "501 Snowdrift 12mm-Silk",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "502 Sleet 12mm-Silk",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "503 Circa 12mm-Silk",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "506 Mirabel 12mm-Silk",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "511 Smokestone 12mm-Ultra Rough",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "516 Locura 12mm-Honed",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "545 Fossillia 12mm Honed Porcelain",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "550 Silvax 12mm-Stone",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "584 Opal Taj 12mm Honed Porcelain",
        type: "Porcelain",
        price: 727.5
      },
      {
        name: "311 Graphite Metal 20mm H P-CS porcelain",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "501 Snowdrift 20mm-Silk",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "502 Sleet 20mm-Silk",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "503 Circa 20mm-Silk",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "506 Mirabel 20mm-Silk",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "545 Fossillia 20mm Honed Porcelain",
        type: "Porcelain",
        price: 858.75
      },
      {
        name: "584 Opal Taj 20mm Honed Porcelain",
        type: "Porcelain",
        price: 968.75
      },
      {
        name: "507 Marbannova 12mm-Silk",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "509 Onyxa 12mm Honed Porcelain",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "536 Antikella 12mm Honed Porcelain",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "537 Glacetta 12mm Honed Porcelain",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "551 Travina 12mm Stone Porcelain",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "581 Lucillia 12mm-Silk",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "583 Crestone 12mm H P-CS porcelain",
        type: "Porcelain",
        price: 988.75
      },
      {
        name: "507 Marbannova 20mm-Silk",
        type: "Porcelain",
        price: 1217.5
      },
      {
        name: "537 Glacetta 20mm Honed Porcelain",
        type: "Porcelain",
        price: 1217.5
      },
      {
        name: "551 Travina 20mm Stone Porcelain",
        type: "Porcelain",
        price: 1217.5
      },
      {
        name: "581 Lucillia 20mm-Silk",
        type: "Porcelain",
        price: 1217.5
      },
      {
        name: "583 Crestone 20mm Honed Porcelain",
        type: "Porcelain",
        price: 1217.5
      },
      {
        name: "Porcelain - Aris",
        type: "Porcelain",
        price: 82.5
      },
      {
        name: "Porcelain - Pencil Round",
        type: "Porcelain",
        price: 82.5
      },
      {
        name: "Porcelain - Shark Nose",
        type: "Porcelain",
        price: 206.25
      },
      {
        name: "Porcelain Double Mitred - Aris",
        type: "Porcelain",
        price: 220
      },
      {
        name: "Porcelain Double Mitred - Pencil Round",
        type: "Porcelain",
        price: 220
      },
      {
        name: "Porcelain Mitred - Aris",
        type: "Porcelain",
        price: 165
      },
      {
        name: "Porcelain Mitred - Pencil Round",
        type: "Porcelain",
        price: 165
      },
      {
        name: "Porcelain Cooktop Cutout",
        type: "Porcelain",
        price: 90
      },
      {
        name: "Porcelain Drop in Sink",
        type: "Porcelain",
        price: 90
      },
      {
        name: "Porcelain Farmhouse Sink 20mm inner edge",
        type: "Porcelain",
        price: 412.5
      },
      {
        name: "Porcelain GPO Cutout",
        type: "Porcelain",
        price: 55
      },
      {
        name: "Porcelain Rough Cutout",
        type: "Porcelain",
        price: 103.75
      },
      {
        name: "Porcelain Tap Hole",
        type: "Porcelain",
        price: 41.25
      },
      {
        name: "Porcelain Undermount Sink (Double Bowl)",
        type: "Porcelain",
        price: 447.5
      },
      {
        name: "Porcelain Undermount Sink (Single Bowl)",
        type: "Porcelain",
        price: 343.75
      },
      {
        name: "Porcelain Additional Travel Charge (per km > 50km from fabricator)",
        type: "Porcelain",
        price: 8.75
      },
      {
        name: "Porcelain Additional Trip Charge",
        type: "Porcelain",
        price: 275
      },
      {
        name: "Porcelain DIY surcharge",
        type: "Porcelain",
        price: 825
      },
      {
        name: "Porcelain Drop down BBQ Niche",
        type: "Porcelain",
        price: 481.25
      },
      {
        name: "Porcelain Heavy Lift Charge (per job where single piece > 2.5sqm)",
        type: "Porcelain",
        price: 343.75
      },
      {
        name: "Porcelain High Rise & Difficult Access Fee",
        type: "Porcelain",
        price: 343.75
      },
      {
        name: "Porcelain Install on Existing Joinery",
        type: "Porcelain",
        price: 550
      },
      {
        name: "Porcelain Misc charges",
        type: "Porcelain",
        price: 1.25
      },
      {
        name: "Porcelain Polish Underside of Overhangs (up to 300mm)",
        type: "Porcelain",
        price: 151.25
      },
      {
        name: "Porcelain Site Template Fee",
        type: "Porcelain",
        price: 261.25
      },
      {
        name: "Porcelain Vein Matching Option (per join)",
        type: "Porcelain",
        price: 412.5
      },
      {
        name: "Porcelain Waterfall End (Installation ONLY)",
        type: "Porcelain",
        price: 302.5
      }
    ],
    porcelainColours: [
      {
        id: "110-whitenna",
        code: "110",
        name: "Whitenna",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 628.75,
          "20": 830
        }
      },
      {
        id: "411-concrita",
        code: "411",
        name: "Concrita",
        finish: "Ultra Rough",
        note: null,
        ratesExGst: {
          "12": 628.75
        }
      },
      {
        id: "504-lumena",
        code: "504",
        name: "Lumena",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 628.75,
          "20": 830
        }
      },
      {
        id: "531-libretta",
        code: "531",
        name: "Libretta",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 628.75,
          "20": 830
        }
      },
      {
        id: "580-fume",
        code: "580",
        name: "Fume",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 628.75
        }
      },
      {
        id: "311-graphite-metal",
        code: "311",
        name: "Graphite Metal",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "410-aluminous",
        code: "410",
        name: "Aluminous",
        finish: "Ultra Rough",
        note: null,
        ratesExGst: {
          "12": 727.5
        }
      },
      {
        id: "413-white-ciment",
        code: "413",
        name: "White Ciment",
        finish: "Ultra Rough",
        note: null,
        ratesExGst: {
          "12": 727.5
        }
      },
      {
        id: "501-snowdrift",
        code: "501",
        name: "Snowdrift",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "502-sleet",
        code: "502",
        name: "Sleet",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "503-circa",
        code: "503",
        name: "Circa",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "506-mirabel",
        code: "506",
        name: "Mirabel",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "511-smokestone",
        code: "511",
        name: "Smokestone",
        finish: "Ultra Rough",
        note: null,
        ratesExGst: {
          "12": 727.5
        }
      },
      {
        id: "516-locura",
        code: "516",
        name: "Locura",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 727.5
        }
      },
      {
        id: "545-fossillia",
        code: "545",
        name: "Fossillia",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 858.75
        }
      },
      {
        id: "550-silvax",
        code: "550",
        name: "Silvax",
        finish: "Stone",
        note: null,
        ratesExGst: {
          "12": 727.5
        }
      },
      {
        id: "584-opal-taj",
        code: "584",
        name: "Opal Taj",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 727.5,
          "20": 968.75
        }
      },
      {
        id: "507-marbannova",
        code: "507",
        name: "Marbannova",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 988.75,
          "20": 1217.5
        }
      },
      {
        id: "509-onyxa",
        code: "509",
        name: "Onyxa",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 988.75
        }
      },
      {
        id: "536-antikella",
        code: "536",
        name: "Antikella",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 988.75
        }
      },
      {
        id: "537-glacetta",
        code: "537",
        name: "Glacetta",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 988.75,
          "20": 1217.5
        }
      },
      {
        id: "551-travina",
        code: "551",
        name: "Travina",
        finish: "Stone",
        note: null,
        ratesExGst: {
          "12": 988.75,
          "20": 1217.5
        }
      },
      {
        id: "581-lucillia",
        code: "581",
        name: "Lucillia",
        finish: "Silk",
        note: null,
        ratesExGst: {
          "12": 988.75,
          "20": 1217.5
        }
      },
      {
        id: "583-crestone",
        code: "583",
        name: "Crestone",
        finish: "Honed",
        note: null,
        ratesExGst: {
          "12": 988.75,
          "20": 1217.5
        }
      }
    ],
    porcelainBands: [
      628.75,
      727.5,
      988.75
    ],
    porcelainEdges: [
      {
        id: "aris",
        name: "Porcelain - Aris",
        pricePerMExGst: 82.5
      },
      {
        id: "pencil-round",
        name: "Porcelain - Pencil Round",
        pricePerMExGst: 82.5
      },
      {
        id: "shark-nose",
        name: "Porcelain - Shark Nose",
        pricePerMExGst: 206.25
      },
      {
        id: "double-mitred-aris",
        name: "Porcelain Double Mitred - Aris",
        pricePerMExGst: 220
      },
      {
        id: "double-mitred-pencil-round",
        name: "Porcelain Double Mitred - Pencil Round",
        pricePerMExGst: 220
      },
      {
        id: "mitred-aris",
        name: "Porcelain Mitred - Aris",
        pricePerMExGst: 165
      },
      {
        id: "mitred-pencil-round",
        name: "Porcelain Mitred - Pencil Round",
        pricePerMExGst: 165
      }
    ],
    porcelainCutouts: [
      {
        id: "cooktop-cutout",
        name: "Porcelain Cooktop Cutout",
        priceEachExGst: 90
      },
      {
        id: "drop-in-sink",
        name: "Porcelain Drop in Sink",
        priceEachExGst: 90
      },
      {
        id: "farmhouse-sink-20mm-inner-edge",
        name: "Porcelain Farmhouse Sink 20mm inner edge",
        priceEachExGst: 412.5
      },
      {
        id: "gpo-cutout",
        name: "Porcelain GPO Cutout",
        priceEachExGst: 55
      },
      {
        id: "rough-cutout",
        name: "Porcelain Rough Cutout",
        priceEachExGst: 103.75
      },
      {
        id: "tap-hole",
        name: "Porcelain Tap Hole",
        priceEachExGst: 41.25
      },
      {
        id: "undermount-sink-double-bowl",
        name: "Porcelain Undermount Sink (Double Bowl)",
        priceEachExGst: 447.5
      },
      {
        id: "undermount-sink-single-bowl",
        name: "Porcelain Undermount Sink (Single Bowl)",
        priceEachExGst: 343.75
      }
    ],
    porcelainExtras: [
      {
        id: "additional-travel-charge-per-km-50km-from-fabricator",
        name: "Porcelain Additional Travel Charge (per km > 50km from fabricator)",
        priceExGst: 8.75
      },
      {
        id: "additional-trip-charge",
        name: "Porcelain Additional Trip Charge",
        priceExGst: 275
      },
      {
        id: "diy-surcharge",
        name: "Porcelain DIY surcharge",
        priceExGst: 825
      },
      {
        id: "drop-down-bbq-niche",
        name: "Porcelain Drop down BBQ Niche",
        priceExGst: 481.25
      },
      {
        id: "heavy-lift-charge-per-job-where-single-piece-2-5sqm",
        name: "Porcelain Heavy Lift Charge (per job where single piece > 2.5sqm)",
        priceExGst: 343.75
      },
      {
        id: "high-rise-difficult-access-fee",
        name: "Porcelain High Rise & Difficult Access Fee",
        priceExGst: 343.75
      },
      {
        id: "install-on-existing-joinery",
        name: "Porcelain Install on Existing Joinery",
        priceExGst: 550
      },
      {
        id: "misc-charges",
        name: "Porcelain Misc charges",
        priceExGst: 1.25
      },
      {
        id: "polish-underside-of-overhangs-up-to-300mm",
        name: "Porcelain Polish Underside of Overhangs (up to 300mm)",
        priceExGst: 151.25
      },
      {
        id: "site-template-fee",
        name: "Porcelain Site Template Fee",
        priceExGst: 261.25
      },
      {
        id: "vein-matching-option-per-join",
        name: "Porcelain Vein Matching Option (per join)",
        priceExGst: 412.5
      },
      {
        id: "waterfall-end-installation-only",
        name: "Porcelain Waterfall End (Installation ONLY)",
        priceExGst: 302.5
      }
    ]
  };

  // .planner-src/apps/web/lib/benchtop-prices.ts
  var MATERIAL_LABEL = {
    mineral: "Mineral",
    porcelain: "Porcelain"
  };
  var BENCHTOP_COLOUR_PRICES = price_list_default.colours.map((c) => ({
    ...c,
    material: "mineral",
    ratesExGst: { "20": c.pricePerSqmExGst }
  }));
  var PORCELAIN_COLOUR_PRICES = price_list_default.porcelainColours.map((c) => ({
    ...c,
    material: "porcelain",
    pricePerSqmExGst: Math.min(...Object.values(c.ratesExGst))
  }));
  var ALL_COLOUR_PRICES = [...BENCHTOP_COLOUR_PRICES, ...PORCELAIN_COLOUR_PRICES];
  var BENCHTOP_BANDS_EX_GST = price_list_default.bands;
  var PORCELAIN_BANDS_EX_GST = price_list_default.porcelainBands;
  function colourThicknesses(c) {
    return Object.keys(c.ratesExGst).map((k) => Number(k)).sort((a, b) => a - b);
  }
  function defaultThickness(c) {
    return colourThicknesses(c)[0];
  }
  function resolveThickness(c, wanted) {
    const ts = colourThicknesses(c);
    return wanted !== void 0 && ts.includes(wanted) ? wanted : ts[0];
  }
  function rateFor(c, thicknessMm) {
    const r = c.ratesExGst[String(thicknessMm)];
    if (r === void 0) throw new Error(`${c.id} is not priced at ${thicknessMm} mm`);
    return r;
  }
  var GST_RATE = 0.1;
  var SITE_TEMPLATE_FEE_EX_GST = 261.25;
  var WATERFALL_INSTALL_EX_GST = 247.5;
  var MINIMUM_STONE_SQM = 3;
  var AREA_STEP_SQM = 0.1;
  var EDGE_STEP_M = 0.01;
  var byName = (rows, name, key) => {
    const r = rows.find((x) => x.name === name);
    const v = r == null ? void 0 : r[key];
    if (v === void 0) throw new Error(`price list has no "${name}"`);
    return v;
  };
  var mineralEdge = (n) => byName(price_list_default.edges, n, "pricePerMExGst");
  var porcelainEdge = (n) => byName(price_list_default.porcelainEdges, n, "pricePerMExGst");
  var mineralCutout = (n) => byName(price_list_default.cutouts, n, "priceEachExGst");
  var porcelainCutout = (n) => byName(price_list_default.porcelainCutouts, n, "priceEachExGst");
  var mineralExtra = (n) => byName(price_list_default.extras, n, "priceExGst");
  var porcelainExtra = (n) => byName(price_list_default.porcelainExtras, n, "priceExGst");
  function waterfallInstallExGst(material) {
    return material === "porcelain" ? porcelainExtra("Porcelain Waterfall End (Installation ONLY)") : WATERFALL_INSTALL_EX_GST;
  }
  var BENCHTOP_EDGES = [
    {
      id: "standard",
      label: "Standard 20 mm Pencil Round",
      listName: "20mm - Pencil Round",
      pricePerMExGst: mineralEdge("20mm - Pencil Round"),
      thicknessMm: 20,
      materialSqmPerM: 0
    },
    {
      id: "chunky",
      label: "Chunky 40 mm Double Mitred",
      listName: "Double Mitred - Pencil Round",
      pricePerMExGst: mineralEdge("Double Mitred - Pencil Round"),
      thicknessMm: 40,
      materialSqmPerM: 0.1
    }
  ];
  var PORCELAIN_EDGES = [
    {
      id: "standard",
      label: "Pencil Round",
      listName: "Porcelain - Pencil Round",
      pricePerMExGst: porcelainEdge("Porcelain - Pencil Round"),
      thicknessMm: null,
      materialSqmPerM: 0
    },
    {
      id: "chunky",
      label: "Chunky 40 mm Double Mitred",
      listName: "Porcelain Double Mitred - Pencil Round",
      pricePerMExGst: porcelainEdge("Porcelain Double Mitred - Pencil Round"),
      thicknessMm: 40,
      materialSqmPerM: 0.1
    }
  ];
  var DEFAULT_EDGE = "standard";
  function edgesFor(material) {
    return material === "porcelain" ? PORCELAIN_EDGES : BENCHTOP_EDGES;
  }
  function edgeOption(id, material = "mineral") {
    var _a;
    const edges = edgesFor(material);
    return (_a = edges.find((e) => e.id === (id != null ? id : DEFAULT_EDGE))) != null ? _a : edges[0];
  }
  var CUTOUT_PRICES = [
    { id: "dropin", label: "Drop in sink", listName: "Drop in Sink", priceEachExGst: mineralCutout("Drop in Sink") },
    { id: "undermount1", label: "Undermount sink, single bowl", listName: "Undermount Sink (Single Bowl)", priceEachExGst: mineralCutout("Undermount Sink (Single Bowl)") },
    { id: "undermount2", label: "Undermount sink, double bowl", listName: "Undermount Sink (Double Bowl)", priceEachExGst: mineralCutout("Undermount Sink (Double Bowl)") },
    { id: "farmhouse20", label: "Farmhouse sink, 20 mm inner edge", listName: "CS OPT - Farmhouse Sink 20mm inner edge", priceEachExGst: mineralCutout("CS OPT - Farmhouse Sink 20mm inner edge") },
    { id: "farmhouse40", label: "Farmhouse sink, 40 mm inner edge", listName: "Farmhouse Sink 40mm inner edge", priceEachExGst: mineralCutout("Farmhouse Sink 40mm inner edge") },
    { id: "cooktop", label: "Cooktop cutout", listName: "Cooktop Cutout", priceEachExGst: mineralCutout("Cooktop Cutout") },
    { id: "tap", label: "Tap hole", listName: "Tap Hole", priceEachExGst: mineralCutout("Tap Hole") },
    { id: "gpo", label: "GPO cutout", listName: "GPO Cutout", priceEachExGst: mineralCutout("GPO Cutout") }
  ];
  var PORCELAIN_CUTOUT_PRICES = [
    { id: "dropin", label: "Drop in sink", listName: "Porcelain Drop in Sink", priceEachExGst: porcelainCutout("Porcelain Drop in Sink") },
    { id: "undermount1", label: "Undermount sink, single bowl", listName: "Porcelain Undermount Sink (Single Bowl)", priceEachExGst: porcelainCutout("Porcelain Undermount Sink (Single Bowl)") },
    { id: "undermount2", label: "Undermount sink, double bowl", listName: "Porcelain Undermount Sink (Double Bowl)", priceEachExGst: porcelainCutout("Porcelain Undermount Sink (Double Bowl)") },
    { id: "farmhouse20", label: "Farmhouse sink, 20 mm inner edge", listName: "Porcelain Farmhouse Sink 20mm inner edge", priceEachExGst: porcelainCutout("Porcelain Farmhouse Sink 20mm inner edge") },
    { id: "cooktop", label: "Cooktop cutout", listName: "Porcelain Cooktop Cutout", priceEachExGst: porcelainCutout("Porcelain Cooktop Cutout") },
    { id: "tap", label: "Tap hole", listName: "Porcelain Tap Hole", priceEachExGst: porcelainCutout("Porcelain Tap Hole") },
    { id: "gpo", label: "GPO cutout", listName: "Porcelain GPO Cutout", priceEachExGst: porcelainCutout("Porcelain GPO Cutout") }
  ];
  var SINK_CUTOUT_IDS = ["dropin", "undermount1", "undermount2", "farmhouse20", "farmhouse40"];
  function cutoutsFor(material) {
    return material === "porcelain" ? PORCELAIN_CUTOUT_PRICES : CUTOUT_PRICES;
  }
  function sinkCutoutIdsFor(material) {
    const have = new Set(cutoutsFor(material).map((c) => c.id));
    return SINK_CUTOUT_IDS.filter((id) => have.has(id));
  }
  function cutoutPrice(id, material = "mineral") {
    const c = cutoutsFor(material).find((x) => x.id === id);
    if (!c) throw new Error(`no ${material} cutout ${id}`);
    return c;
  }
  var extra = (id, label, note, mineralName, porcelainName) => ({
    id,
    label,
    note,
    listName: { mineral: mineralName, porcelain: porcelainName },
    priceExGst: { mineral: mineralExtra(mineralName), porcelain: porcelainExtra(porcelainName) }
  });
  var EXTRAS = [
    extra("high-rise", "High Rise and Difficult Access", "For sites with lifts, stairs or a long carry.", "High Rise & Difficult Access Charge", "Porcelain High Rise & Difficult Access Fee"),
    extra("heavy-lift", "Heavy Lift", "For stone pieces requiring extra crew to carry.", "Heavy Lift Charge (per job where single piece > 2.5sqm)", "Porcelain Heavy Lift Charge (per job where single piece > 2.5sqm)"),
    /* MAT'S CORRECTION (2026-09-21): the list's "DIY surcharge" is charged
       when the CUSTOMER installed the cabinets themselves, because
       self-installed joinery is often not level and the stone takes longer
       to fit. It is NOT supply only and it removes nothing; the words the
       customer reads say exactly that. The list row and the price are
       unchanged. */
    extra("diy", "Kitchen installed by you", "Extra charge when you have installed the cabinets yourself, because self-installed joinery is often not level and the stone takes longer to fit.", "DIY surcharge", "Porcelain DIY surcharge"),
    extra("additional-trip", "Additional Trip", "One extra visit to site.", "Additional Trip Charge", "Porcelain Additional Trip Charge"),
    extra("install-existing", "Install on existing or second hand kitchen", "Fitting onto cabinets that are already in place.", "Install on Existing Joinery", "Porcelain Install on Existing Joinery")
  ];
  var EXTRA_IDS = EXTRAS.map((e) => e.id);
  var POLISH_UNDERSIDE = {
    label: "Polish underside of overhangs",
    note: "For overhangs deeper than 100 mm, up to 300 mm. Enter the length of overhang edge in metres.",
    listName: {
      mineral: "Polish Underside of Overhangs (up to 300mm)",
      porcelain: "Porcelain Polish Underside of Overhangs (up to 300mm)"
    },
    pricePerMExGst: {
      mineral: mineralExtra("Polish Underside of Overhangs (up to 300mm)"),
      porcelain: porcelainExtra("Porcelain Polish Underside of Overhangs (up to 300mm)")
    },
    /** The most a link may carry, metres. */
    maxM: 50,
    stepM: 0.1
  };
  var VEIN_MATCHING = {
    label: "Vein matching",
    listName: { mineral: "Vein Matching", porcelain: "Porcelain Vein Matching Option (per join)" },
    pricePerJoinExGst: {
      mineral: mineralExtra("Vein Matching"),
      porcelain: porcelainExtra("Porcelain Vein Matching Option (per join)")
    },
    /** The most joins a link may carry. */
    maxJoins: 40
  };
  var SLAB_LENGTH_MM = 3050;
  function edgesAvailable(material, thicknessMm) {
    const all = edgesFor(material);
    return material === "porcelain" && thicknessMm === 12 ? all.filter((e) => e.id !== "chunky") : all;
  }
  function resolveEdge(material, thicknessMm, wanted) {
    const id = wanted != null ? wanted : DEFAULT_EDGE;
    const ok = edgesAvailable(material, thicknessMm).some((e) => e.id === id);
    return ok ? { edge: id, fellBack: false } : { edge: DEFAULT_EDGE, fellBack: id !== DEFAULT_EDGE };
  }
  function extraOption(id) {
    const e = EXTRAS.find((x) => x.id === id);
    if (!e) throw new Error(`no extra ${id}`);
    return e;
  }
  function colourRateExGst(colourId) {
    var _a, _b;
    return (_b = (_a = ALL_COLOUR_PRICES.find((c) => c.id === colourId)) == null ? void 0 : _a.pricePerSqmExGst) != null ? _b : null;
  }
  function incGst(exGst) {
    return roundCents(exGst * (1 + GST_RATE));
  }
  function roundCents(v) {
    return Math.round(v * 100) / 100;
  }
  function bandLabel(rateExGst) {
    return `from ${formatAud(incGst(rateExGst))} per sqm`;
  }
  function formatAud(v) {
    return `$${v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // .planner-src/apps/web/lib/benchtop-estimate.ts
  var NOTHING_TO_PRICE_NOTE = "No benchtop section is in this estimate. Restore a section to price the job.";
  function roundUpSqm(v) {
    const steps = 1 / AREA_STEP_SQM;
    return Math.ceil(v * steps - 1e-9) / steps;
  }
  function roundEdgeM(v) {
    return Math.round(v * (1 / EDGE_STEP_M)) / (1 / EDGE_STEP_M);
  }
  var fix = (v, d) => Number(v.toFixed(d));
  function estimateBenchtop(input) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
    const material = (_a = input.material) != null ? _a : "mineral";
    const thicknessMm = (_b = input.thicknessMm) != null ? _b : 20;
    if (!edgesAvailable(material, thicknessMm).some((e) => e.id === input.edge)) {
      throw new Error(`${material} at ${thicknessMm} mm does not offer the ${input.edge} edge`);
    }
    const edge = edgeOption(input.edge, material);
    const rate = input.ratePerSqmExGst;
    const lines = [];
    const notes = [];
    if (input.runs.length === 0 && input.waterfalls.length === 0) {
      return {
        colourId: input.colourId,
        colourName: input.colourName,
        material,
        thicknessMm,
        edge: input.edge,
        areas: [],
        stoneSqmMeasured: 0,
        stoneSqmCharged: 0,
        splashbackSqm: 0,
        splashbackEdgeM: 0,
        minimumApplied: false,
        edgeM: 0,
        lines,
        subtotalExGst: 0,
        gst: 0,
        totalIncGst: 0,
        notes: [NOTHING_TO_PRICE_NOTE],
        nothingToPrice: true
      };
    }
    const areas = [];
    let stone = 0;
    for (const r of input.runs) {
      const charged = fix(roundUpSqm(r.areaSqm), 1);
      areas.push({ id: r.id, label: r.label, measuredSqm: fix(r.areaSqm, 3), chargedSqm: charged });
      stone += charged;
    }
    for (const w of input.waterfalls) {
      const charged = fix(roundUpSqm(w.panelSqm), 1);
      areas.push({ id: w.id, label: `${w.label} waterfall panel${w.fromPlan ? ", from your plan" : ""}`, measuredSqm: fix(w.panelSqm, 3), chargedSqm: charged });
      stone += charged;
    }
    let edgeM = 0;
    for (const r of input.runs) edgeM += r.exposedEdgeM;
    for (const w of input.waterfalls) edgeM += w.edgeM;
    edgeM = fix(roundEdgeM(edgeM), 2);
    const splashEdge = edgeOption((_c = input.splashbackEdge) != null ? _c : "standard", material);
    let splashEdgeM = 0;
    for (const s of (_d = input.splashbacks) != null ? _d : []) splashEdgeM += s.edgeM;
    splashEdgeM = fix(roundEdgeM(splashEdgeM), 2);
    const edgeStone = fix(roundUpSqm(edge.materialSqmPerM * edgeM + splashEdge.materialSqmPerM * splashEdgeM), 1);
    let splashCharged = 0;
    for (const s of (_e = input.splashbacks) != null ? _e : []) {
      const charged = fix(roundUpSqm(s.areaSqm), 1);
      areas.push({ id: s.id, label: `${s.label} splashback`, measuredSqm: fix(s.areaSqm, 3), chargedSqm: charged });
      splashCharged = fix(splashCharged + charged, 1);
    }
    const stoneMeasured = fix(stone + edgeStone + splashCharged, 2);
    const minimumApplied = stoneMeasured < MINIMUM_STONE_SQM;
    const stoneCharged = minimumApplied ? MINIMUM_STONE_SQM : stoneMeasured;
    const benchCharged = fix(stoneCharged - splashCharged, 2);
    lines.push({
      kind: "stone",
      label: `${input.colourName}, ${thicknessMm} mm`,
      detail: minimumApplied ? splashCharged > 0 ? `${stoneMeasured.toFixed(1)} sqm measured with the splashback, 3 sqm minimum applies, ${benchCharged.toFixed(1)} sqm at ${aud(rate)} per sqm` : `${stoneMeasured.toFixed(1)} sqm measured, 3 sqm minimum applies, at ${aud(rate)} per sqm` : `${benchCharged.toFixed(1)} sqm at ${aud(rate)} per sqm`,
      qty: benchCharged,
      unit: "sqm",
      rateExGst: rate,
      amountExGst: roundCents(benchCharged * rate)
    });
    if (minimumApplied) notes.push("3 sqm minimum applies");
    for (const s of (_f = input.splashbacks) != null ? _f : []) if (s.note) notes.push(`${s.label}: ${s.note}`);
    if (splashCharged > 0) {
      const sRate = (_g = input.splashbackRatePerSqmExGst) != null ? _g : rate;
      const sThick = (_h = input.splashbackThicknessMm) != null ? _h : material === "porcelain" ? 12 : 20;
      const runsWords = ((_i = input.splashbacks) != null ? _i : []).map((s) => `${s.label} ${(s.lengthMm / 1e3).toFixed(2)} m`).join(", ");
      lines.push({
        kind: "splashback",
        label: `${input.colourName} splashback, ${sThick} mm`,
        detail: `${splashCharged.toFixed(1)} sqm at ${aud(sRate)} per sqm, ${runsWords}`,
        qty: splashCharged,
        unit: "sqm",
        rateExGst: sRate,
        amountExGst: roundCents(splashCharged * sRate)
      });
    }
    if (edgeStone > 0) {
      const mitredM = fix((edge.materialSqmPerM > 0 ? edgeM : 0) + (splashEdge.materialSqmPerM > 0 ? splashEdgeM : 0), 2);
      lines.push({
        kind: "edge-material",
        label: "Stone for the mitred edge",
        detail: `${mitredM.toFixed(2)} m at ${edge.materialSqmPerM.toFixed(2)} sqm per metre, ${edgeStone.toFixed(1)} sqm in the stone above`,
        qty: edgeStone,
        unit: "sqm",
        rateExGst: rate,
        amountExGst: 0
      });
    }
    if (edgeM > 0) {
      lines.push({
        kind: "edge",
        label: `${edge.label} edge`,
        detail: `${edgeM.toFixed(2)} m at ${aud(edge.pricePerMExGst)} per metre`,
        qty: edgeM,
        unit: "m",
        rateExGst: edge.pricePerMExGst,
        amountExGst: roundCents(edgeM * edge.pricePerMExGst)
      });
    }
    if (splashEdgeM > 0) {
      lines.push({
        kind: "splashback-edge",
        label: `${splashEdge.label} edge, splashback`,
        detail: `${splashEdgeM.toFixed(2)} m of exposed splashback edge at ${aud(splashEdge.pricePerMExGst)} per metre`,
        qty: splashEdgeM,
        unit: "m",
        rateExGst: splashEdge.pricePerMExGst,
        amountExGst: roundCents(splashEdgeM * splashEdge.pricePerMExGst)
      });
    }
    if (input.waterfalls.length > 0) {
      const n = input.waterfalls.length;
      const install = waterfallInstallExGst(material);
      lines.push({
        kind: "waterfall-install",
        label: `Waterfall end install, ${n} end${n === 1 ? "" : "s"}`,
        detail: `${n} at ${aud(install)} each, panels priced as stone above`,
        qty: n,
        unit: "each",
        rateExGst: install,
        amountExGst: roundCents(n * install)
      });
    }
    for (const c of input.cutouts) {
      if (c.qty <= 0) continue;
      const p = cutoutPrice(c.id, material);
      lines.push({
        kind: "cutout",
        label: p.label,
        detail: `${c.qty} at ${aud(p.priceEachExGst)} each`,
        qty: c.qty,
        unit: "each",
        rateExGst: p.priceEachExGst,
        amountExGst: roundCents(c.qty * p.priceEachExGst)
      });
    }
    const sGpo = (_j = input.splashbackGpo) != null ? _j : 0;
    if (sGpo > 0) {
      const p = cutoutPrice("gpo", material);
      lines.push({
        kind: "splashback-cutout",
        label: `${p.label}, splashback`,
        detail: `${sGpo} at ${aud(p.priceEachExGst)} each`,
        qty: sGpo,
        unit: "each",
        rateExGst: p.priceEachExGst,
        amountExGst: roundCents(sGpo * p.priceEachExGst)
      });
    }
    const vm = input.veinMatching;
    if (vm && vm.joins > 0) {
      const perJoin = VEIN_MATCHING.pricePerJoinExGst[material];
      lines.push({
        kind: "vein-matching",
        label: `${VEIN_MATCHING.label}, ${vm.joins} join${vm.joins === 1 ? "" : "s"} at ${aud(perJoin)}`,
        detail: vm.typed ? "join count set by you" : `from the plan: runs over ${(SLAB_LENGTH_MM / 1e3).toFixed(2)} m and the seams between runs`,
        qty: vm.joins,
        unit: "each",
        rateExGst: perJoin,
        amountExGst: roundCents(vm.joins * perJoin)
      });
    }
    for (const id of (_k = input.extras) != null ? _k : []) {
      const x = extraOption(id);
      const price = x.priceExGst[material];
      lines.push({
        kind: "extra",
        label: x.label,
        detail: `once per job, ${aud(price)}`,
        qty: 1,
        unit: "each",
        rateExGst: price,
        amountExGst: price
      });
    }
    const polishM = (_l = input.polishUndersideM) != null ? _l : 0;
    if (polishM > 0) {
      const m = Number((Math.ceil(polishM * 10 - 1e-9) / 10).toFixed(1));
      const perM = POLISH_UNDERSIDE.pricePerMExGst[material];
      lines.push({
        kind: "extra",
        label: POLISH_UNDERSIDE.label,
        detail: `${m.toFixed(1)} m of overhang edge at ${aud(perM)} per metre`,
        qty: m,
        unit: "m",
        rateExGst: perM,
        amountExGst: roundCents(m * perM)
      });
    }
    lines.push({
      kind: "template",
      label: "Site template fee",
      detail: "included in every estimate",
      qty: 1,
      unit: "each",
      rateExGst: SITE_TEMPLATE_FEE_EX_GST,
      amountExGst: SITE_TEMPLATE_FEE_EX_GST
    });
    const subtotalExGst = roundCents(lines.reduce((s, l) => s + l.amountExGst, 0));
    const gst = roundCents(subtotalExGst * GST_RATE);
    const totalIncGst = roundCents(subtotalExGst + gst);
    return {
      colourId: input.colourId,
      colourName: input.colourName,
      material,
      thicknessMm,
      edge: input.edge,
      areas,
      stoneSqmMeasured: stoneMeasured,
      stoneSqmCharged: stoneCharged,
      splashbackSqm: splashCharged,
      splashbackEdgeM: splashEdgeM,
      minimumApplied,
      edgeM,
      lines,
      subtotalExGst,
      gst,
      totalIncGst,
      notes,
      nothingToPrice: false
    };
  }
  function aud(v) {
    return `$${v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  function estimateFigure(e) {
    return `$${e.totalIncGst.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} incl. GST`;
  }
  var BENCHTOP_ESTIMATE_DISCLAIMER = "Our team confirms the final price after checking your plan and a site template.";
  var BENCHTOP_NOT_IN_TOTAL = "Benchtop estimate, not included in your order total, confirmed by our team";

  // src/website-input.mjs
  var website_input_exports = {};
  __export(website_input_exports, {
    BENCH_HEIGHT_MM: () => BENCH_HEIGHT_MM,
    DEFAULT_BENCH_HEIGHT_MM: () => DEFAULT_BENCH_HEIGHT_MM,
    MAX_CUTOUT_COUNT: () => MAX_CUTOUT_COUNT,
    RUN_DEPTH_MM: () => RUN_DEPTH_MM,
    RUN_LENGTH_MM: () => RUN_LENGTH_MM,
    SECTION_DEPTH_MM: () => SECTION_DEPTH_MM,
    SECTION_LENGTH_MM: () => SECTION_LENGTH_MM,
    SPLASHBACK_DEFAULT_HEIGHT_MM: () => SPLASHBACK_DEFAULT_HEIGHT_MM,
    SPLASHBACK_HEIGHT_MM: () => SPLASHBACK_HEIGHT_MM,
    SPLASHBACK_MIN_LENGTH_MM: () => SPLASHBACK_MIN_LENGTH_MM,
    TRAY: () => TRAY,
    WEBSITE_WORDS: () => WEBSITE_WORDS,
    buildWebsiteInput: () => buildWebsiteInput,
    colourPrice: () => colourPrice,
    estimateWebsiteJob: () => estimateWebsiteJob,
    meetsWall: () => meetsWall,
    priceBySection: () => priceBySection,
    quickPriceLines: () => quickPriceLines,
    sectionJoins: () => sectionJoins,
    splashbackEdgeNote: () => splashbackEdgeNote,
    splashbackFor: () => splashbackFor,
    splashbackThicknessMm: () => splashbackThicknessMm,
    veinState: () => veinState,
    veinStep: () => veinStep
  });

  // src/planner-stub.mjs
  var planOnly = (name) => () => {
    throw new Error(`${name} needs the 3D planner's plan and is not part of the website bundle`);
  };
  var seamPairs = () => [];
  var benchtopColour = planOnly("benchtopColour");
  var measureSplashback = planOnly("measureSplashback");
  var drawnBenchThicknessMm = planOnly("drawnBenchThicknessMm");
  var measureBenchtop = planOnly("measureBenchtop");
  var waterfallPanelMm = planOnly("waterfallPanelMm");
  var waterfallOnIds = planOnly("waterfallOnIds");
  var cabinetPlacement = planOnly("cabinetPlacement");
  var isWallCabinet = planOnly("isWallCabinet");

  // .planner-src/apps/web/lib/benchtop-splashback.ts
  var SPLASHBACK_DEFAULT_HEIGHT_MM = 600;
  var SPLASHBACK_HEIGHT_MM = [100, 1500];
  var SPLASHBACK_MIN_LENGTH_MM = 100;
  function splashbackThicknessMm(material) {
    return material === "porcelain" ? 12 : 20;
  }

  // .planner-src/apps/web/lib/benchtop-input.ts
  function effectiveCutouts(plan, room, material = "mineral") {
    var _a, _b, _c, _d;
    const d = plan.defaultCutouts;
    const c = room == null ? void 0 : room.cutouts;
    if (!c) return d;
    const sink = c.sink === null ? null : sinkCutoutIdsFor(material).includes(c.sink) ? c.sink : d.sink;
    return {
      sink,
      sinks: (_a = c.sinks) != null ? _a : d.sinks,
      cooktops: (_b = c.cooktops) != null ? _b : d.cooktops,
      taps: (_c = c.taps) != null ? _c : d.taps,
      gpo: (_d = c.gpo) != null ? _d : d.gpo
    };
  }
  function cutoutLines(c) {
    const out = [];
    if (c.sink && c.sinks > 0) out.push({ id: c.sink, qty: c.sinks });
    if (c.cooktops > 0) out.push({ id: "cooktop", qty: c.cooktops });
    if (c.taps > 0) out.push({ id: "tap", qty: c.taps });
    if (c.gpo > 0) out.push({ id: "gpo", qty: c.gpo });
    return out;
  }
  function activeBoards(plan) {
    return plan.boards.filter((b) => !b.removed);
  }
  function planJoins(plan) {
    const runs = activeBoards(plan).map((b) => ({
      id: b.id,
      label: b.label,
      lengthMm: b.frame.lengthMm,
      joins: Math.max(0, Math.ceil(b.frame.lengthMm / SLAB_LENGTH_MM - 1e-9) - 1)
    }));
    const labelOf = (id) => {
      var _a, _b;
      return (_b = (_a = plan.boards.find((b) => b.id === id)) == null ? void 0 : _a.label) != null ? _b : id;
    };
    const seams = seamPairs(plan).map(([a, b]) => ({ a, b, labels: `${labelOf(a)} to ${labelOf(b)}` }));
    const slabJoins = runs.reduce((s, r) => s + r.joins, 0);
    return { total: slabJoins + seams.length, slabJoins, seamJoins: seams.length, runs, seams };
  }
  function veinMatchingFor(plan, room) {
    if ((room == null ? void 0 : room.veinMatching) !== true) return null;
    const plansOwn = planJoins(plan).total;
    const typed = room.veinJoins;
    const joins = typed !== void 0 ? Math.min(VEIN_MATCHING.maxJoins, Math.max(1, typed)) : plansOwn;
    if (joins <= 0) return null;
    return { joins, typed: typed !== void 0 };
  }

  // .planner-src/planner-constants.mjs
  var MAX_CUTOUT_COUNT = 12;
  var RUN_LENGTH_MM = [100, 6e3];
  var RUN_DEPTH_MM = [100, 1500];

  // src/website-input.mjs
  var DEFAULT_BENCH_HEIGHT_MM = 900;
  var BENCH_HEIGHT_MM = [500, 1200];
  var SECTION_LENGTH_MM = RUN_LENGTH_MM;
  var SECTION_DEPTH_MM = RUN_DEPTH_MM;
  var TRAY = {
    noSink: "No sink cutout",
    sink: "Sink",
    sinks: "Sinks",
    cooktops: "Cooktop cutouts",
    taps: "Tap holes",
    gpo: "Power point (GPO) cutouts, benchtop",
    extrasNote: "Each extra is a flat charge, once per job.",
    splashbackToggle: "Stone splashback, same colour as the benchtop",
    splashbackGpo: "Power point (GPO) cutouts, splashback",
    splashbackGpoNote: "each, itemised apart from the benchtop's.",
    splashbackEdgeNote: "The bottom sits on the bench; an edge under a cabinet, under a window sill or into a corner is not charged; the cut at a window or door is.",
    veinToggle: "Vein matching across the joins",
    veinJoins: "Joins to match",
    perJoin: "per join.",
    chunkyNeeds20: "The 40 mm Double Mitred edge needs 20 mm porcelain.",
    perMetre: "per metre",
    estimate: "Estimate",
    breakdown: "Breakdown",
    subtotal: "Subtotal ex GST",
    gst: "GST 10%",
    total: "Estimate incl. GST",
    notInTotal: "Not included in your order total.",
    quoteIntroEnd: "with your details and the installation address.",
    installationAddress: "Installation address",
    message: "Anything about the benchtop we should know (optional)",
    errName: "Please enter your full name.",
    errEmail: "Please enter an email address we can reply to.",
    errPhone: "Please enter a phone number.",
    errStreet: "Please enter the street address.",
    errSuburb: "Please enter the suburb.",
    errState: "Please choose the state.",
    errPostcode: "Please enter the 4 digit postcode."
  };
  var WEBSITE_WORDS = {
    cutoutsHelp: "Set how many of each your benchtop needs.",
    splashbackDesc: "Up the wall behind every section that meets one.",
    noWall: "No section meets a wall, so there is nothing to put a splashback on.",
    /* Mat, 2026-10-08: keep the minus / plus count, no automatic corner joins, and this line under it. */
    veinCount: "Add one join for each corner where two benchtops meet."
  };
  var clamp = (v, [lo, hi], fallback) => {
    const n = Math.round(Number(v));
    return Number.isFinite(n) && String(v).trim() !== "" ? Math.min(hi, Math.max(lo, n)) : fallback;
  };
  var count = (v) => Math.max(0, Math.min(MAX_CUTOUT_COUNT, Math.floor(Number(v) || 0)));
  function colourPrice(priceListId) {
    const c = ALL_COLOUR_PRICES.find((x) => x.id === priceListId);
    if (!c) throw new Error(`no price-list row ${priceListId}`);
    return c;
  }
  function meetsWall(section) {
    return !(section.exposed && section.exposed.back);
  }
  function splashbackFor(section) {
    var _a, _b, _c, _d, _e;
    const sb = section.splashback || {};
    const L = clamp(section.lengthMm, RUN_LENGTH_MM, RUN_LENGTH_MM[0]);
    const ex = section.exposed || {};
    const wf = section.waterfall || {};
    return {
      off: sb.off === true,
      heightMm: clamp((_a = sb.heightMm) != null ? _a : SPLASHBACK_DEFAULT_HEIGHT_MM, SPLASHBACK_HEIGHT_MM, SPLASHBACK_DEFAULT_HEIGHT_MM),
      lengthMm: clamp((_b = sb.lengthMm) != null ? _b : L, [SPLASHBACK_MIN_LENGTH_MM, L], L),
      top: (_c = sb.top) != null ? _c : true,
      left: (_d = sb.left) != null ? _d : Boolean(ex.left || wf.left),
      right: (_e = sb.right) != null ? _e : Boolean(ex.right || wf.right)
    };
  }
  function planOf(sections) {
    return {
      boards: sections.map((s, i) => ({
        id: `s${i + 1}`,
        label: String(s.name || `Section ${i + 1}`).slice(0, 40),
        removed: false,
        frame: { lengthMm: clamp(s.lengthMm, RUN_LENGTH_MM, RUN_LENGTH_MM[0]) }
      })),
      defaultCutouts: { sink: null, sinks: 0, cooktops: 0, taps: 0, gpo: 0 }
    };
  }
  function sectionJoins(sections) {
    return planJoins(planOf(sections || []));
  }
  function buildWebsiteInput(job) {
    var _a, _b, _c, _d, _e;
    const c = colourPrice(job.priceListId);
    const material = c.material;
    const thicknessMm = resolveThickness(c, job.thicknessMm);
    const { edge, fellBack } = resolveEdge(material, thicknessMm, job.edge);
    const H = clamp((_a = job.benchHeightMm) != null ? _a : DEFAULT_BENCH_HEIGHT_MM, BENCH_HEIGHT_MM, DEFAULT_BENCH_HEIGHT_MM);
    const sections = (_b = job.sections) != null ? _b : [];
    const plan = planOf(sections);
    const runs = [];
    const waterfalls = [];
    sections.forEach((s, i) => {
      var _a2, _b2;
      const { id, label } = plan.boards[i];
      const L = clamp(s.lengthMm, RUN_LENGTH_MM, RUN_LENGTH_MM[0]);
      const D = clamp(s.depthMm, RUN_DEPTH_MM, RUN_DEPTH_MM[0]);
      const ex = (_a2 = s.exposed) != null ? _a2 : {};
      const wf = (_b2 = s.waterfall) != null ? _b2 : {};
      let edgeMm = (ex.front ? L : 0) + (ex.back ? L : 0);
      for (const end of ["left", "right"]) {
        if (wf[end]) waterfalls.push({ id: `${id}-${end}`, label: `${label}, ${end} end`, panelSqm: D * H / 1e6, edgeM: 2 * H / 1e3 });
        else if (ex[end]) edgeMm += D;
      }
      runs.push({ id, label, areaSqm: L * D / 1e6, exposedEdgeM: edgeMm / 1e3 });
    });
    const wantSink = job.sink && job.sink !== "none" ? job.sink : null;
    const room = {
      cutouts: { sink: wantSink, sinks: count((_c = job.sinks) != null ? _c : wantSink ? 1 : 0), cooktops: count(job.cooktops), taps: count(job.taps), gpo: count((_d = job.gpo) != null ? _d : job.gpos) }
    };
    const effective = effectiveCutouts(plan, room, material);
    const sinkRefused = wantSink !== null && effective.sink !== wantSink;
    const cutouts = cutoutLines(effective);
    const extras = [...new Set(((_e = job.extras) != null ? _e : []).filter((x) => EXTRA_IDS.includes(x)))].sort();
    const p = Number(job.polishUndersideM);
    const polishUndersideM = Number.isFinite(p) ? Math.min(POLISH_UNDERSIDE.maxM, Math.max(0, Math.round(p * 10) / 10)) : 0;
    const input = {
      colourId: c.id,
      colourName: job.colourName || c.name,
      ratePerSqmExGst: rateFor(c, thicknessMm),
      material,
      thicknessMm,
      edge,
      runs,
      waterfalls,
      cutouts,
      extras,
      polishUndersideM
    };
    const wallSections = sections.map((s, i) => ({ s, i })).filter(({ s }) => meetsWall(s));
    if (job.splashback && wallSections.length > 0) {
      const sbThick = splashbackThicknessMm(material);
      input.splashbacks = wallSections.map(({ s, i }) => ({ sb: splashbackFor(s), b: plan.boards[i] })).filter(({ sb }) => !sb.off).map(({ sb, b }) => ({
        id: `${b.id}-splashback`,
        label: b.label,
        areaSqm: sb.lengthMm * sb.heightMm / 1e6,
        lengthMm: sb.lengthMm,
        edgeM: ((sb.top ? sb.lengthMm : 0) + (sb.left ? sb.heightMm : 0) + (sb.right ? sb.heightMm : 0)) / 1e3
      }));
      input.splashbackRatePerSqmExGst = rateFor(c, sbThick);
      input.splashbackThicknessMm = sbThick;
      input.splashbackEdge = resolveEdge(material, sbThick, job.edge).edge;
      if (count(job.splashbackGpo) > 0) input.splashbackGpo = count(job.splashbackGpo);
    }
    const typedJoins = Number.isFinite(job.veinJoins) && job.veinJoins > 0 ? job.veinJoins : void 0;
    const vm = job.veinMatching ? veinMatchingFor(plan, { veinMatching: true, veinJoins: typedJoins }) : null;
    if (vm) input.veinMatching = vm;
    return { input, thicknessMm, edge, edgeFellBack: fellBack, sinkRefused, benchHeightMm: H, joins: planJoins(plan) };
  }
  function estimateWebsiteJob(job) {
    const built = buildWebsiteInput(job);
    return { ...built, estimate: estimateBenchtop(built.input) };
  }
  function priceBySection(result) {
    var _a, _b;
    const { estimate: est, input } = result;
    if (est.nothingToPrice) return null;
    const m = input.material;
    const rate = input.ratePerSqmExGst;
    const edge = edgeOption(input.edge, m);
    const sEdge = edgeOption((_a = input.splashbackEdge) != null ? _a : "standard", m);
    const sRate = (_b = input.splashbackRatePerSqmExGst) != null ? _b : rate;
    const install = waterfallInstallExGst(m);
    const charged = (id) => (est.areas.find((a) => a.id === id) || { chargedSqm: 0 }).chargedSqm;
    const splashOf = (run) => {
      var _a2;
      return ((_a2 = input.splashbacks) != null ? _a2 : []).find((s) => s.id === `${run.id}-splashback`);
    };
    const fallsOf = (run) => input.waterfalls.filter((w) => w.id.startsWith(`${run.id}-`));
    const rawBench = input.runs.map((run) => run.exposedEdgeM + fallsOf(run).reduce((t, w) => t + w.edgeM, 0));
    const rawSplash = input.runs.map((run) => splashOf(run) ? splashOf(run).edgeM : 0);
    const sumB = rawBench.reduce((a, b) => a + b, 0);
    const sumS = rawSplash.reduce((a, b) => a + b, 0);
    const benchM = rawBench.map((v) => sumB > 0 ? v * est.edgeM / sumB : 0);
    const splashM = rawSplash.map((v) => sumS > 0 ? v * est.splashbackEdgeM / sumS : 0);
    const edgeStoneSqm = (est.lines.find((l) => l.kind === "edge-material") || { qty: 0 }).qty;
    const mitred = input.runs.map((run, i) => (edge.materialSqmPerM > 0 ? benchM[i] : 0) + (sEdge.materialSqmPerM > 0 ? splashM[i] : 0));
    const mitredTotal = mitred.reduce((a, b) => a + b, 0);
    const sections = input.runs.map((run, i) => {
      const falls = fallsOf(run);
      const sb = splashOf(run);
      const stone = (charged(run.id) + falls.reduce((t, w) => t + charged(w.id), 0)) * rate + (mitredTotal > 0 ? edgeStoneSqm * mitred[i] / mitredTotal : 0) * rate;
      const edgeEx = benchM[i] * edge.pricePerMExGst;
      const waterfall = falls.length * install;
      const splashback = sb ? charged(sb.id) * sRate + splashM[i] * sEdge.pricePerMExGst : 0;
      return {
        id: run.id,
        label: run.label,
        chargedSqm: charged(run.id),
        edgeM: run.exposedEdgeM,
        waterfallEnds: falls.length,
        waterfallSqm: falls.reduce((t, w) => t + charged(w.id), 0),
        splashbackSqm: sb ? charged(sb.id) : 0,
        splashbackEdgeM: sb ? sb.edgeM : 0,
        partsExGst: { stone, edge: edgeEx, waterfall, splashback },
        exGst: stone + edgeEx + waterfall + splashback
      };
    });
    const JOB_KINDS = ["cutout", "splashback-cutout", "vein-matching", "extra", "template"];
    const job = est.lines.filter((l) => JOB_KINDS.includes(l.kind)).map((l) => ({ kind: l.kind, label: l.label, detail: l.detail, qty: l.qty, unit: l.unit, exGst: l.amountExGst, incGst: incGst(l.amountExGst) }));
    const topUp = est.minimumApplied ? (() => {
      const sqm = Number((est.stoneSqmCharged - est.stoneSqmMeasured).toFixed(2));
      const ex = sqm * rate;
      return { sqm, measuredSqm: est.stoneSqmMeasured, exGst: ex, incGst: roundCents(ex * (1 + GST_RATE)) };
    })() : null;
    const cents = (v) => Math.round(v * 100);
    const totalC = cents(est.totalIncGst);
    const fixedC = job.reduce((t, l) => t + cents(l.incGst), 0) + (topUp ? cents(topUp.incGst) : 0);
    const exact = sections.map((s) => s.exGst * (1 + GST_RATE) * 100);
    const base = exact.map((v) => Math.floor(v + 1e-9));
    let rem = totalC - fixedC - base.reduce((a, b) => a + b, 0);
    const rows = exact.map((v, i) => ({ i, frac: Math.round((v - base[i]) * 1e6) / 1e6, size: v }));
    const up = rows.slice().sort((a, b) => b.frac - a.frac || b.size - a.size);
    const down = rows.slice().sort((a, b) => a.frac - b.frac || b.size - a.size);
    for (let k = 0; rem > 0 && up.length; k++, rem--) base[up[k % up.length].i] += 1;
    for (let k = 0; rem < 0 && down.length; k++, rem++) base[down[k % down.length].i] -= 1;
    sections.forEach((s, i) => {
      s.incGst = base[i] / 100;
    });
    const workingEx = sections.reduce((t, s) => t + s.exGst, 0) + job.reduce((t, l) => t + l.exGst, 0) + (topUp ? topUp.exGst : 0);
    return { sections, job, topUp, gst: est.gst, totalIncGst: est.totalIncGst, roundingCents: Math.round((est.subtotalExGst - workingEx) * 100 * 1e3) / 1e3 };
  }
  var aud2 = (v) => `$${v.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  var incAud = (ex) => aud2(incGst(ex));
  function veinState(sections, veinMatching, veinJoins) {
    const own = sectionJoins(sections || []).total;
    const typed = Number.isFinite(veinJoins) && veinJoins > 0 ? veinJoins : void 0;
    const vm = veinMatching ? veinMatchingFor(planOf(sections || []), { veinMatching: true, veinJoins: typed }) : null;
    return { own, typed, charged: vm ? vm.joins : 0 };
  }
  function veinStep(sections, veinJoins, delta) {
    const own = sectionJoins(sections || []).total;
    const cur = Number.isFinite(veinJoins) && veinJoins > 0 ? veinJoins : own;
    let next = Math.min(VEIN_MATCHING.maxJoins, cur + delta);
    if (next < 1) return void 0;
    return next === own ? void 0 : next;
  }
  function splashbackEdgeNote(estimate) {
    const l = estimate.lines.find((x) => x.kind === "splashback-edge");
    if (!l) return null;
    return `${l.label}: ${l.qty.toFixed(2)} m at ${incAud(l.rateExGst)} per metre, ${incAud(l.amountExGst)}.`;
  }
  function quickPriceLines(result) {
    const p = priceBySection(result);
    if (!p) return null;
    const est = result.estimate;
    const s = p.sections[0];
    const c = (v) => Math.round(v * 100);
    const stoneOnlyC = c(incGst(s.partsExGst.stone));
    const stoneC = stoneOnlyC + (p.topUp ? c(p.topUp.incGst) : 0);
    const edgeC = c(s.incGst) - stoneOnlyC;
    const rate = result.input.ratePerSqmExGst;
    const edge = edgeOption(result.input.edge, result.input.material);
    const edgeStone = (est.lines.find((l) => l.kind === "edge-material") || { qty: 0 }).qty;
    const stoneLabel = p.topUp ? `${est.stoneSqmMeasured.toFixed(1)} m², charged at the 3 m² minimum × ${incAud(rate)}` : `${est.stoneSqmCharged.toFixed(1)} m² × ${incAud(rate)}${edgeStone > 0 ? `, incl. ${edgeStone.toFixed(1)} m² for the mitred edge` : ""}`;
    const lines = [
      { label: stoneLabel, incGst: stoneC / 100 },
      { label: `${est.edgeM.toFixed(2)} m polished edge × ${incAud(edge.pricePerMExGst)}`, incGst: edgeC / 100 },
      ...p.job.map((l) => ({ label: l.label, incGst: l.incGst }))
    ];
    return { lines, totalIncGst: est.totalIncGst, minimumApplied: est.minimumApplied };
  }
  return __toCommonJS(stone_engine_entry_exports);
})();

(typeof window !== "undefined" ? window : globalThis).CustomeaStoneData = {"priceListSource":"CustomeaAccount markup to print - Retail Price 20/9/2026","priceListDate":"2026-09-20","plannerCommit":"5ddb22a504ab1c11c928bd7b331ad4e72f582550","plannerCommitDate":"2026-10-08T19:00:52+11:00","builtAt":"2026-10-08T09:20:33.942Z","colours":[{"priceListId":"1141-pure-white","handle":"1141-pure-white","code":"1141","name":"Pure White","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":1,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505599910083","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/1141_Pure_White.jpg?v=1714546072","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144145603","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-1141-pure-white-slab.jpg","width":1920,"height":616},"kitchen":{"id":"gid://shopify/MediaImage/48602876149955","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-1141-pure-white-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"2141-snow","handle":"2141-snow","code":"2141","name":"Snow","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":2,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505679798467","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/2141_Snow.jpg?v=1714547664","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144178371","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-2141-snow-slab.jpg","width":1920,"height":616},"kitchen":{"id":"gid://shopify/MediaImage/48602858782915","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-2141-snow-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"3100-jet-black","handle":"3100-jet-black","code":"3100","name":"Jet Black","range":"Mineral","finish":"P","stockNote":null,"tone":"Dark","sort":3,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505684418755","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/3100_Jet_Black.jpg?v=1714547738","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144211139","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-3100-jet-black-slab.jpg","width":1920,"height":616},"kitchen":{"id":"gid://shopify/MediaImage/48602876182723","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-3100-jet-black-kitchen.jpg","width":1200,"height":675}}},{"priceListId":"3141-osprey","handle":"3141-osprey","code":"3141","name":"Osprey","range":"Mineral","finish":"P","stockNote":null,"tone":"Dark","sort":4,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505682157763","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/3141_Osprey.jpg?v=1714547703","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144243907","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-3141-osprey-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876215491","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-3141-osprey-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4030-oyster","handle":"4030-oyster","code":"4030","name":"Oyster","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":5,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505675735235","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4030_Oyster.jpg?v=1714547592","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144276675","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4030-oyster-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876248259","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4030-oyster-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4120-raven","handle":"4120-raven","code":"4120","name":"Raven","range":"Mineral","finish":"P","stockNote":null,"tone":"Dark","sort":6,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505670099139","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4120_Raven.jpg?v=1714547516","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144309443","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4120-raven-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876281027","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4120-raven-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"6011-intense-white","handle":"6011-intense-white","code":"6011","name":"Intense White","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":7,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505665446083","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/6011_Intense_White.jpg?v=1714547460","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144342211","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6011-intense-white-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876313795","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6011-intense-white-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"6141-ocean-foam","handle":"6141-ocean-foam","code":"6141","name":"Ocean Foam","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":8,"band":"M1","thicknesses":[20],"ratesExGst":{"20":505},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505662365891","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/6141_Ocean_Foam.jpg?v=1714547417","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144374979","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6141-ocean-foam-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876346563","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6141-ocean-foam-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4001-fresh-concrete","handle":"4001-fresh-concrete","code":"4001","name":"Fresh Concrete","range":"Mineral","finish":"CN","stockNote":null,"tone":"Concrete","sort":9,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505598861507","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4001_Fresh_Concrete.jpg?v=1714546032","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144407747","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4001-fresh-concrete-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876379331","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4001-fresh-concrete-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4004-raw-concrete","handle":"4004-raw-concrete","code":"4004","name":"Raw Concrete","range":"Mineral","finish":"CN","stockNote":null,"tone":"Concrete","sort":10,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505592144067","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4004_Raw_Concrete.jpg?v=1714545945","width":2100,"height":973},"slab":{"id":"gid://shopify/MediaImage/48602144440515","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4004-raw-concrete-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876412099","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4004-raw-concrete-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4600-organic-white","handle":"4600-organic-white","code":"4600","name":"Organic White","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":11,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505584804035","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4600_Organic_White.jpg?v=1714545841","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144473283","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4600-organic-white-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876444867","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4600-organic-white-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5110-alpine-mist","handle":"5110-alpine-mist","code":"5110","name":"Alpine Mist","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":12,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505577562307","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5110_Alpine_Mist.jpg?v=1714545744","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144506051","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5110-alpine-mist-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876477635","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5110-alpine-mist-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5112-aterra-blanca","handle":"5112-aterra-blanca","code":"5112","name":"Aterra Blanca","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":13,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505544859843","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5112_Aterra_Blanca.jpg?v=1714544504","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144538819","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5112-aterra-blanca-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876510403","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5112-aterra-blanca-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5130-cosmopolitan-white","handle":"5130-cosmopolitan-white","code":"5130","name":"Cosmopolitan White","range":"Mineral","finish":"P","stockNote":"Backorder","tone":"Veined","sort":14,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505574252739","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5130_Cosmopolitan_White.jpg?v=1714545708","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144571587","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5130-cosmopolitan-white-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876543171","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5130-cosmopolitan-white-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5133-symphony-grey","handle":"5133-symphony-grey","code":"5133","name":"Symphony Grey","range":"Mineral","finish":"P","stockNote":"Low Stock","tone":"Veined","sort":15,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505571303619","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5133_Symphony_Grey.jpg?v=1714545666","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144604355","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5133-symphony-grey-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876575939","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5133-symphony-grey-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5141-frosty-carina","handle":"5141-frosty-carrina","code":"5141","name":"Frosty Carrina","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":16,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505541943491","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5141_Frosty_Carrina.jpg?v=1714544319","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144637123","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5141-frosty-carina-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876608707","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5141-frosty-carrina-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5146-misty-river","handle":"5146-misty-river","code":"5146","name":"Misty River","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":17,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601717702851","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5146-misty-river-slab.jpg?v=1791425471","width":4096,"height":2075},"thumb":{"id":"gid://shopify/MediaImage/48601717735619","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5146-misty-river-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602144669891","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5146-misty-river-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602876641475","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5146-misty-river-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"6134-georgian-bluffs","handle":"6134-georgian-bluffs","code":"6134","name":"Georgian Bluffs","range":"Mineral","finish":"P","stockNote":"Low Stock","tone":"Veined","sort":18,"band":"M2","thicknesses":[20],"ratesExGst":{"20":563.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505568813251","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/6134_Georgian_Bluffs.jpg?v=1714545608","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144702659","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6134-georgian-bluffs-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876674243","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6134-georgian-bluffs-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5100-vanilla-noir","handle":"5100-vanilla-noir","code":"5100","name":"Vanilla Noir","range":"Mineral","finish":"P","stockNote":"Backorder","tone":"Veined","sort":19,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505545973955","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5100_Vanilla_Noir.jpg?v=1714544556","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144735427","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5100-vanilla-noir-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876707011","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5100-vanilla-noir-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5102-lace-line","handle":"5102-laceline","code":"5102","name":"Laceline","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":20,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601717768387","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5102-lace-line-slab.jpg?v=1791425471","width":4096,"height":2075},"thumb":{"id":"gid://shopify/MediaImage/48601717801155","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5102-lace-line-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602144768195","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5102-lace-line-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602876739779","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5102-laceline-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5103-light-crest","handle":"5103-lightcrest","code":"5103","name":"Lightcrest","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":21,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601717833923","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5103-light-crest-slab.jpg?v=1791425471","width":4096,"height":2075},"thumb":{"id":"gid://shopify/MediaImage/48601717866691","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5103-light-crest-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602144800963","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5103-light-crest-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602876772547","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5103-lightcrest-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5131-calacatta-nuvo","handle":"5131-calacatta-nuvo","code":"5131","name":"Calacatta Nuvo","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":22,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505533456579","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5131_Calacatta_Nuvo.jpg?v=1714543895","width":1986,"height":921},"slab":{"id":"gid://shopify/MediaImage/48602144833731","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5131-calacatta-nuvo-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876805315","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5131-calacatta-nuvo-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5140-dreamy-carrara","handle":"5140-dreamy-carrara","code":"5140","name":"Dreamy Carrara","range":"Mineral","finish":"H","stockNote":null,"tone":"Veined","sort":23,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505542598851","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5140_Dreamy_Cararra.jpg?v=1714544377","width":2762,"height":1300},"slab":{"id":"gid://shopify/MediaImage/48602144866499","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5140-dreamy-carrara-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876838083","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5140-dreamy-carrara-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5143-white-attica","handle":"5143-white-attica","code":"5143","name":"White Attica","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":24,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505540174019","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5143_White_Attica.jpg?v=1714544240","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144899267","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5143-white-attica-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602876870851","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5143-white-attica-kitchen.jpg","width":1200,"height":675}}},{"priceListId":"5151-empira-white","handle":"5151-empira-white","code":"5151","name":"Empira White","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":25,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505525035203","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5151_Empira_White.jpg?v=1714543440","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144932035","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5151-empira-white-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602876903619","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5151-empira-white-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5310-brillianza","handle":"5310-brillianza","code":"5310","name":"Brillianza","range":"Mineral","finish":"P","stockNote":null,"tone":"White","sort":26,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505537355971","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5310_Brillianza.jpg?v=1714544090","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602144964803","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5310-brillianza-slab.jpg","width":4096,"height":1982},"kitchen":{"id":"gid://shopify/MediaImage/48602876936387","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5310-brillianza-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"6131-bianco-drift","handle":"6131-bianco-drift","code":"6131","name":"Bianco Drift","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":27,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34702109802691","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/6131_Full_Slab.webp?v=1716888764","width":5400,"height":2484},"closeup":{"id":"gid://shopify/MediaImage/48602144997571","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6131-bianco-drift-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602876969155","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6131-bianco-drift-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"6313-turbine-grey","handle":"6313-turbine-grey","code":"6313","name":"Turbine Grey","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":28,"band":"M3","thicknesses":[20],"ratesExGst":{"20":633.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34505534898371","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/6313_Turbine_Grey_9027566b-255f-4ad4-92b1-f89aa143fd3e.jpg?v=1714543974","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145030339","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6313-turbine-grey-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602877001923","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-6313-turbine-grey-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4011-cloudburst-concrete-csf","handle":"4011-cloudburst-concrete","code":"4011","name":"Cloudburst Concrete","range":"Mineral","finish":"OR","stockNote":null,"tone":"Concrete","sort":29,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505561604291","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4011_Cloudburst_Concrete.jpg?v=1714545182","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145063107","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4011-cloudburst-concrete-csf-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602877034691","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4011-cloudburst-concrete-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4033-rugged-concrete","handle":"4033-rugged-concrete","code":"4033","name":"Rugged Concrete","range":"Mineral","finish":"R","stockNote":null,"tone":"Concrete","sort":30,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505559900355","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4033_Rugged_Concrete.jpg?v=1714545119","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145095875","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4033-rugged-concrete-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602877067459","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4033-rugged-concrete-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"4044-airy-concrete-csf","handle":"4044-airy-concrete","code":"4044","name":"Airy Concrete","range":"Mineral","finish":"OR","stockNote":null,"tone":"Concrete","sort":31,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505558687939","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/4044_Airy_Concrete.jpg?v=1714545073","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145128643","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4044-airy-concrete-csf-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602877100227","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-4044-airy-concrete-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5031-statuario-maximus","handle":"5031-statuario-maximus","code":"5031","name":"Statuario Maximus","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":32,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505533980867","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5031_Statuario_Maximus.jpg?v=1714543941","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145161411","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5031-statuario-maximus-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602877132995","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5031-statuario-maximus-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5113-solenna","handle":"5113-solenna","code":"5113","name":"Solenna","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":33,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34506139041987","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5113_Solenna.jpg?v=1714555442","width":5000,"height":3333},"slab":{"id":"gid://shopify/MediaImage/48602145194179","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5113-solenna-slab.jpg","width":1920,"height":902},"kitchen":{"id":"gid://shopify/MediaImage/48602877165763","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5113-solenna-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5171-arabetto","handle":"5171-arabetto","code":"5171","name":"Arabetto","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":34,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505539649731","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5171_Arabetto.jpg?v=1714544196","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145226947","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5171-arabetto-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602877198531","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5171-arabetto-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5222-adamina","handle":"5222-adamina","code":"5222","name":"Adamina","range":"Mineral","finish":"OR","stockNote":"Backorder","tone":"Veined","sort":35,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505538142403","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5222_Adamina.jpg?v=1714544124","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145259715","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5222-adamina-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602877231299","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5222-adamina-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5441-glacier-flow","handle":"5441-glacier-flow","code":"5441","name":"Glacier Flow","range":"Mineral","finish":"P","stockNote":"Low Stock","tone":"Veined","sort":36,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601717899459","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5441-glacier-flow-slab.jpg?v=1791425471","width":3840,"height":1812},"thumb":{"id":"gid://shopify/MediaImage/48601717932227","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5441-glacier-flow-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145292483","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5441-glacier-flow-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885456067","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5441-glacier-flow-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5444-lunar-frost","handle":"5444-lunar-frost","code":"5444","name":"Lunar Frost","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":37,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601717964995","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5444-lunar-frost-slab.jpg?v=1791425471","width":3840,"height":1812},"thumb":{"id":"gid://shopify/MediaImage/48601717997763","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5444-lunar-frost-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145325251","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5444-lunar-frost-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885488835","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5444-lunar-frost-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5810-black-tempal","handle":"5810-black-tempal","code":"5810","name":"Black Tempal","range":"Mineral","finish":"OR","stockNote":null,"tone":"Dark","sort":38,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34505535946947","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/5810_BlackTempal.jpg?v=1714544017","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145358019","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5810-black-tempal-slab.jpg","width":2048,"height":966},"kitchen":{"id":"gid://shopify/MediaImage/48602885521603","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5810-black-tempal-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"8252-sedara","handle":"8252-sedara","code":"8252","name":"Sedara","range":"Mineral","series":"ICON","finish":"P","stockNote":null,"tone":"Veined","sort":39,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718030531","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8252-sedara-slab.jpg?v=1791425472","width":3840,"height":1812},"thumb":{"id":"gid://shopify/MediaImage/48601718063299","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8252-sedara-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145390787","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8252-sedara-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885554371","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8252-sedara-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"8252-taj-whisper","handle":"8251-taj-whisper","code":"8251","name":"Taj Whisper","range":"Mineral","series":"ICON","finish":"P","stockNote":null,"tone":"Veined","sort":40,"band":"M4","thicknesses":[20],"ratesExGst":{"20":807.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/37139680362691","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/Taj_Whisper_1282x715_RGB-1024x571.jpg?v=1777724963","width":1024,"height":571},"slab":{"id":"gid://shopify/MediaImage/48602145423555","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8252-taj-whisper-slab.jpg","width":4096,"height":2026},"kitchen":{"id":"gid://shopify/MediaImage/48602885587139","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8251-taj-whisper-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5105-calacatta-dreamwave","handle":"5105-calacatta-dreamwave","code":"5105","name":"Calacatta Dreamwave","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":41,"band":"M5","thicknesses":[20],"ratesExGst":{"20":981.25},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718096067","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5105-calacatta-dreamwave-slab.jpg?v=1791425471","width":3840,"height":1812},"thumb":{"id":"gid://shopify/MediaImage/48601718128835","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5105-calacatta-dreamwave-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145456323","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5105-calacatta-dreamwave-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885619907","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5105-calacatta-dreamwave-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5115-calacatta-stillstorm","handle":"5115-calacatta-stillstorm","code":"5115","name":"Calacatta Stillstorm","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":42,"band":"M5","thicknesses":[20],"ratesExGst":{"20":981.25},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718161603","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5115-calacatta-stillstorm-slab.jpg?v=1791425471","width":1920,"height":906},"thumb":{"id":"gid://shopify/MediaImage/48601718194371","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5115-calacatta-stillstorm-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145489091","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5115-calacatta-stillstorm-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885652675","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5115-calacatta-stillstorm-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5132-celestial-sky","handle":"5132-celestial-sky","code":"5132","name":"Celestial Sky","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":43,"band":"M5","thicknesses":[20],"ratesExGst":{"20":981.25},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718227139","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5132-celestial-sky-slab.jpg?v=1791425471","width":1920,"height":906},"thumb":{"id":"gid://shopify/MediaImage/48601718259907","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5132-celestial-sky-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145521859","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5132-celestial-sky-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885685443","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5132-celestial-sky-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"5144-rossa-nova","handle":"5144-rossa-nova","code":"5144","name":"Rossa Nova","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":44,"band":"M5","thicknesses":[20],"ratesExGst":{"20":981.25},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718292675","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5144-rossa-nova-slab.jpg?v=1791425471","width":1920,"height":906},"thumb":{"id":"gid://shopify/MediaImage/48601718325443","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5144-rossa-nova-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145554627","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5144-rossa-nova-closeup.jpg","width":1024,"height":1558},"kitchen":{"id":"gid://shopify/MediaImage/48602885718211","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-5144-rossa-nova-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"8100-calacatta-lacebound","handle":"8100-calacatta-lacebound","code":"8100","name":"Calacatta Lacebound","range":"Mineral","finish":"P","stockNote":null,"tone":"Veined","sort":45,"band":"M5","thicknesses":[20],"ratesExGst":{"20":981.25},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718358211","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8100-calacatta-lacebound-slab.jpg?v=1791425471","width":4096,"height":2021},"thumb":{"id":"gid://shopify/MediaImage/48601718390979","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8100-calacatta-lacebound-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145587395","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8100-calacatta-lacebound-closeup.jpg","width":1024,"height":1691},"kitchen":{"id":"gid://shopify/MediaImage/48602885750979","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-8100-calacatta-lacebound-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"110-whitenna","handle":"110-whitenna","code":"110","name":"Whitenna","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"White","sort":101,"band":"P1","thicknesses":[12,20],"ratesExGst":{"12":628.75,"20":830},"images":{"slab":{"id":"gid://shopify/MediaImage/34506263560387","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/110_Whitenna.jpg?v=1714557634","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145620163","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-110-whitenna-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885783747","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-110-whitenna-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"411-concrita","handle":"411-concrita","code":"411","name":"Concrita","range":"Porcelain","finish":"Ultra Rough","stockNote":null,"tone":"Concrete","sort":102,"band":"P1","thicknesses":[12],"ratesExGst":{"12":628.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34506333454531","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/411_Concrita.jpg?v=1714559003","width":5153,"height":2578},"slab":{"id":"gid://shopify/MediaImage/48602145652931","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-411-concrita-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885816515","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-411-concrita-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"504-lumena","handle":"504-lumena","code":"504","name":"Lumena","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":103,"band":"P1","thicknesses":[12,20],"ratesExGst":{"12":628.75,"20":830},"images":{"slab":{"id":"gid://shopify/MediaImage/34506384834755","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/504_Lumena.png?v=1714560000","width":3822,"height":1212},"closeup":{"id":"gid://shopify/MediaImage/48602145685699","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-504-lumena-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885849283","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-504-lumena-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"531-libretta","handle":"531-libretta","code":"531","name":"Libretta","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":104,"band":"P1","thicknesses":[12,20],"ratesExGst":{"12":628.75,"20":830},"images":{"slab":{"id":"gid://shopify/MediaImage/34506403152067","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/531_Libreta.jpg?v=1714560203","width":3812,"height":1202},"closeup":{"id":"gid://shopify/MediaImage/48602145718467","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-531-libretta-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885882051","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-531-libretta-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"580-fume","handle":"580-fume","code":"580","name":"Fume","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Concrete","sort":105,"band":"P1","thicknesses":[12],"ratesExGst":{"12":628.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34506409083075","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/580_Fume.jpg?v=1714560257","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145751235","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-580-fume-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885914819","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-580-fume-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"311-graphite-metal","handle":"311-graphite-metal","code":"311","name":"Graphite Metal","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Dark","sort":106,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718423747","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-311-graphite-metal-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718456515","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-311-graphite-metal-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602145784003","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-311-graphite-metal-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602885947587","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-311-graphite-metal-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"410-aluminous","handle":"410-aluminous","code":"410","name":"Aluminous","range":"Porcelain","finish":"Ultra Rough","stockNote":null,"tone":"Concrete","sort":107,"band":"P2","thicknesses":[12],"ratesExGst":{"12":727.5},"images":{"slab":{"id":"gid://shopify/MediaImage/34506330833091","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/410_Aluminous.jpg?v=1714558967","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145816771","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-410-aluminous-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602885980355","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-410-aluminous-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"413-white-ciment","handle":"413-white-ciment","code":"413","name":"White Ciment","range":"Porcelain","finish":"Ultra Rough","stockNote":null,"tone":"Concrete","sort":108,"band":"P2","thicknesses":[12],"ratesExGst":{"12":727.5},"images":{"slab":{"id":"gid://shopify/MediaImage/34506365894851","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/413_White_Ciment.jpg?v=1714559579","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145849539","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-413-white-ciment-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886013123","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-413-white-ciment-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"501-snowdrift","handle":"501-snowdrift","code":"501","name":"Snowdrift","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"Veined","sort":109,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"closeup":{"id":"gid://shopify/MediaImage/34506378346691","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/501_Snowdrift.jpg?v=1714559863","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602145882307","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-501-snowdrift-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886045891","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-501-snowdrift-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"502-sleet","handle":"502-sleet","code":"502","name":"Sleet","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"Veined","sort":110,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34506382180547","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/502_Sleet.jpg?v=1714559942","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145915075","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-502-sleet-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886078659","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-502-sleet-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"503-circa","handle":"503-circa","code":"503","name":"Circa","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"Veined","sort":111,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34506383392963","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/503_Circa.jpg?v=1714559966","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145947843","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-503-circa-closeup.jpg","width":890,"height":890},"kitchen":{"id":"gid://shopify/MediaImage/48602886111427","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-503-circa-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"506-mirabel","handle":"506-mirabel","code":"506","name":"Mirabel","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"Veined","sort":112,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"slab":{"id":"gid://shopify/MediaImage/34506387947715","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/506_Mirabel.jpg?v=1714560058","width":1920,"height":616},"closeup":{"id":"gid://shopify/MediaImage/48602145980611","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-506-mirabel-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886144195","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-506-mirabel-kitchen.jpg","width":3840,"height":2160}}},{"priceListId":"511-smokestone","handle":"511-smokestone","code":"511","name":"Smokestone","range":"Porcelain","finish":"Ultra Rough","stockNote":null,"tone":"Dark","sort":113,"band":"P2","thicknesses":[12],"ratesExGst":{"12":727.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34702091681987","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/511_Smokestone_CU_1920X890_RGB_25072023.webp?v=1716888638","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602146013379","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-511-smokestone-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886176963","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-511-smokestone-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"516-locura","handle":"516-locura","code":"516","name":"Locura","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Dark","sort":114,"band":"P2","thicknesses":[12],"ratesExGst":{"12":727.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34506399318211","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/516_Locura.jpg?v=1714560160","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602146046147","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-516-locura-slab.jpg","width":3840,"height":1812}}},{"priceListId":"545-fossillia","handle":"545-fossillia","code":"545","name":"Fossillia","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"White","sort":115,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":858.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718489283","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-545-fossillia-slab.jpg?v=1791425472","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718522051","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-545-fossillia-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146078915","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-545-fossillia-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886209731","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-545-fossillia-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"550-silvax","handle":"550-silvax","code":"550","name":"Silvax","range":"Porcelain","finish":"Stone","stockNote":null,"tone":"Veined","sort":116,"band":"P2","thicknesses":[12],"ratesExGst":{"12":727.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34701991542979","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/550_Silvax_CU_1920x890_RGB_280324.jpg?v=1716888015","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602146111683","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-550-silvax-slab.jpg","width":1920,"height":906},"kitchen":{"id":"gid://shopify/MediaImage/48602886242499","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-550-silvax-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"584-opal-taj","handle":"584-opal-taj","code":"584","name":"Opal Taj","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":117,"band":"P2","thicknesses":[12,20],"ratesExGst":{"12":727.5,"20":968.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718554819","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-584-opal-taj-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718587587","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-584-opal-taj-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146144451","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-584-opal-taj-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886275267","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-584-opal-taj-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"507-marbannova","handle":"507-marbannova","code":"507","name":"Marbannova","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"Veined","sort":118,"band":"P3","thicknesses":[12,20],"ratesExGst":{"12":988.75,"20":1217.5},"images":{"slab":{"id":"gid://shopify/MediaImage/34702103412931","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/507_Marbannova_Full_RGB_280324_1_-1.webp?v=1716888721","width":3360,"height":1701},"closeup":{"id":"gid://shopify/MediaImage/48602146177219","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-507-marbannova-closeup.jpg","width":1812,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886308035","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-507-marbannova-kitchen.jpg","width":1920,"height":1082}}},{"priceListId":"509-onyxa","handle":"509-onyxa","code":"509","name":"Onyxa","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":119,"band":"P3","thicknesses":[12],"ratesExGst":{"12":988.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718620355","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-509-onyxa-slab.jpg?v=1791425472","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718653123","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-509-onyxa-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146209987","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-509-onyxa-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886340803","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-509-onyxa-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"536-antikella","handle":"536-antikella","code":"536","name":"Antikella","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":120,"band":"P3","thicknesses":[12],"ratesExGst":{"12":988.75},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718685891","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-536-antikella-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718718659","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-536-antikella-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146242755","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-536-antikella-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886373571","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-536-antikella-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"537-glacetta","handle":"537-glacetta","code":"537","name":"Glacetta","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Veined","sort":121,"band":"P3","thicknesses":[12,20],"ratesExGst":{"12":988.75,"20":1217.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718751427","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-537-glacetta-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718784195","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-537-glacetta-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146275523","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-537-glacetta-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886406339","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-537-glacetta-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"551-travina","handle":"551-travina","code":"551","name":"Travina","range":"Porcelain","finish":"Stone","stockNote":null,"tone":"Veined","sort":122,"band":"P3","thicknesses":[12,20],"ratesExGst":{"12":988.75,"20":1217.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718816963","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-551-travina-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718849731","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-551-travina-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146308291","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-551-travina-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886439107","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-551-travina-kitchen.jpg","width":1282,"height":716}}},{"priceListId":"581-lucillia","handle":"581-lucillia","code":"581","name":"Lucillia","range":"Porcelain","finish":"Silk","stockNote":null,"tone":"White","sort":123,"band":"P3","thicknesses":[12,20],"ratesExGst":{"12":988.75,"20":1217.5},"images":{"closeup":{"id":"gid://shopify/MediaImage/34701985054915","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/581_Lucillia_CU_1920X890_sRGB_250123.jpg?v=1716887976","width":1920,"height":890},"slab":{"id":"gid://shopify/MediaImage/48602146341059","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-581-lucillia-slab.jpg","width":3840,"height":1812},"kitchen":{"id":"gid://shopify/MediaImage/48602886471875","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-581-lucillia-kitchen.jpg","width":1920,"height":1080}}},{"priceListId":"583-crestone","handle":"583-crestone","code":"583","name":"Crestone","range":"Porcelain","finish":"Honed","stockNote":null,"tone":"Concrete","sort":124,"band":"P3","thicknesses":[12,20],"ratesExGst":{"12":988.75,"20":1217.5},"images":{"slab":{"id":"gid://shopify/MediaImage/48601718882499","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-583-crestone-slab.jpg?v=1791425471","width":4096,"height":2060},"thumb":{"id":"gid://shopify/MediaImage/48601718915267","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-583-crestone-thumb.jpg?v=1791425471","width":256,"height":256},"closeup":{"id":"gid://shopify/MediaImage/48602146373827","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-583-crestone-closeup.jpg","width":2060,"height":2060},"kitchen":{"id":"gid://shopify/MediaImage/48602886504643","url":"https://cdn.shopify.com/s/files/1/0642/0925/6643/files/caesarstone-583-crestone-kitchen.jpg","width":1920,"height":1080}}}]};
